/* unplugin-vue-components disabled */import script from "./VideoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoDialog.vue?vue&type=script&setup=true&lang=js"

import "./VideoDialog.vue?vue&type=style&index=0&id=cf3e8cc6&lang=scss&scoped=true"
import "./VideoDialog.vue?vue&type=style&index=1&id=cf3e8cc6&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户哈尔滨医科大学-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf3e8cc6"]])

export default __exports__